export default __webpack_public_path__ + "static/media/NewFooter.c8c3413c.svg";